/** Deploy date — orgs created before this skip onboarding unless reset by super-admin */
export const ONBOARDING_REQUIRED_AFTER = import.meta.env.VITE_ONBOARDING_REQUIRED_AFTER
  || '2026-08-22T00:00:00.000Z';

export const ONBOARDING_ADMIN_ROLES = ['admin', 'owner', 'super_admin'];
